<template>
  <view class="radio-group-disabled-demo">
    <view class="cube-radio-group-example">
      <cube-radio-group
        options="{{ options }}"
        wx:model="{{ checkedValue }}"
        wx:model-prop="value"
        disabled="{{true}}"
      ></cube-radio-group>
    </view>
    <view class="view-desc">selected value: {{ checkedValue }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data: {
      options: [
        {
          value: 'Option1',
          text: 'Option1',
          position: 'right'
        },
        {
          value: 'Option2',
          text: 'Option2',
          position: 'right'
        },
        {
          value: 'Option3',
          text: 'Option3',
          disabled: true,
          position: 'right'
        }
      ],
      checkedValue: ''
    }
  })
</script>

<style lang="stylus">
.radio-group-disabled-demo
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "view-desc": "../../components/desc/index",
    "cube-radio-group": "@mpxjs/mpx-cube-ui/src/components/radio-group/index"
  }
}
</script>
